import { LoginForm } from '@/features/auth';
import { useTranslation } from 'react-i18next';

export const LoginPage = () => {
  const { t } = useTranslation();

  return (
    <div className="flex h-full w-full items-center xl:justify-between justify-center">
      <LoginForm />

      <div className="hidden xl:block">
        <div className="flex flex-col justify-end items-end">
          <h1 className="text-white text-[60px] text-right font-bold font-montserrat leading-none ">
            {t('label.the_most')}
          </h1>
          <h1 className="text-white text-[50px] text-right font-bold font-montserrat leading-none ">
            {t('label.effective')}
          </h1>
          <h1 className="text-white text-[200px] text-right font-bold leading-none font-montserrat">
            OOH
          </h1>
          <h1 className="text-white text-[27px] text-right font-semibold font-montserrat leading-none ">
            {t('label.increase_revenue_text')}
          </h1>
          <h1 className="text-white text-[27px] text-right font-semibold font-montserrat leading-none w-9/12">
            {t('label.affordable_text')}
          </h1>
        </div>
      </div>
    </div>
  );
};
